module.exports = __webpack_public_path__ + "static/media/1.20c3b17b.png";